<template>
  <div class="template-items-modal">
    <base-modal-ex :active.sync="active"
      :animation-in="animationIn"
      :animation-out="animationOut"
      :animation-duration="animationDuration"
      :can-cancel="false"
      has-modal-card>
      <div class="model-content">

        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Select Items
              <!-- Choose Items from: {{ selectedTemplate.name }} -->
            </p>
          </header>

          <section class="modal-card-body">
            <div class="columns m-0">
              <div class="column is-one-quarter">
                <div class="field">
                  Template Name : <strong>{{ selectedTemplate.name }}</strong>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  Tags :
                  <template v-if="selectedTagIDs.length">
                    <span v-for="tag in tags.filter(t => selectedTagIDs.includes(t.tagID))"
                      :key="tag.tagID"
                      class="tag-short mr-1"
                      :style="{ backgroundColor: tag.colorHex, color: getTextColor(tag.colorHex), marginBottom: '2px' }">
                      {{ tag.shortTag }}
                    </span>
                  </template>
                </div>
              </div>
              <div class="column is-one-third">
                <div class="field">
                  <!-- <label class="label">Add Tag</label> -->
                  <div class="control"
                    style="position:relative;">
                    <span class="has-badge-rounded has-badge-medium has-badge-danger"
                      :data-badge="'NEW'" />
                    <div class="dropdown"
                      :class="{ 'is-active': tagDropdownActive }"
                      style="width:100%;"
                      ref="tagDropdown">
                      <div class="dropdown-trigger"
                        style="width:100%;">
                        <div class="input"
                          @click="toggleTagDropdown">
                          <span style="color:#b5b5b5;">Add Tags</span>
                          <span class="icon is-right"
                            style="pointer-events:none;position:absolute;right:10px;">
                            <i class="mdi mdi-menu-down" />
                          </span>
                        </div>
                      </div>
                      <TagsDropdownMenu :tags="tags"
                        :selected-tags="selectedTagIDs"
                        :is-visible="tagDropdownActive"
                        @toggle-tag="toggleTag"
                        @clear-all-tags="clearAllTags" />
                    </div>
                    <!-- <p v-if="tagUpdateMessage"
                      :class="{'has-text-success': tagUpdateSuccess, 'has-text-danger': tagUpdateSuccess === false}"
                      class="mt-2 ml-2">
                      {{ tagUpdateMessage }}
                    </p> -->
                  </div>
                </div>
              </div>
            </div>

            <div v-if="isLoading"
              class="spinner-container">
              <spinner />
            </div>

            <div v-else>
              <!-- <div class="is-flex border-bottom-primary">
                <div class="is-size-4">Items</div>
              </div> -->

              <div class="is-flex mt-4">
                <div class="">
                  <div class="pretty p-icon p-curve p-smooth p-bigger">
                    <input type="checkbox"
                      :checked="areAllSelected"
                      @click="handleSelectAll"
                      :id="'quote-template-items-checkbox-all-items'"
                      :name="'quote-template-items-checkbox-all-items'">
                    <div class="state p-primary">
                      <i class="icon mdi mdi-check" />
                      <label />
                    </div>
                  </div>
                </div>
                <span class="mr-2">
                  Select All
                </span>
              </div>

              <div class="template-items-container">

                <div v-for="(data, index) in sortedData"
                  :key="data.name + index">

                  <div class="template-item-grid is-title mt-5 pt-1 pb-2 mb-2 "
                    :class="`quote-item-heading-${$theme.name}`"
                    v-if="data.items.length > 0">
                    <div class="">
                      <div class="pretty p-icon p-curve p-smooth p-bigger">
                        <input type="checkbox"
                          :disabled="data.items.length === 0"
                          :checked="areAllItemsSelected(data.items)"
                          @click="handleSelectAllItems(data.items)"
                          :id="'quote-template-items-checkbox-all-items'"
                          :name="'quote-template-items-checkbox-all-items'">
                        <div class="state p-primary">
                          <i class="icon mdi mdi-check" />
                          <label />
                        </div>
                      </div>
                    </div>
                    <div style="font-weight: bold;">{{ data.name }} ({{ data.length }})</div>

                    <div class="is-flex is-justify-content-center"
                      v-if="data.items.length > 0">
                      Report
                    </div>
                    <div />
                  </div>

                  <!-- horizontal break -->
                  <!-- <div class="is-divider my-1 mb-3" /> -->

                  <!-- template Items -->
                  <div>
                    <div class="template-item-grid is-size-6 mb-1 ml-5"
                      v-for="(item, indexchild) in data.items"
                      :key="index + indexchild"
                      :value="item">

                      <div>
                        <div class="pretty p-icon p-curve p-smooth p-bigger">
                          <input type="checkbox"
                            :checked="isItemSelected(item)"
                            @click="handleItemClick(item)"
                            :class="true ? 'is-primary' : ''"
                            :id="'quote-template-items-checkbox-child' + index + indexchild"
                            :name="'quote-template-items-checkbox-child' + index + indexchild">
                          <div class="state p-primary">
                            <i class="icon mdi mdi-check" />
                            <label />
                          </div>
                        </div>
                      </div>

                      <div class="">
                        {{ item.itemDesc }}
                      </div>
                      <!-- <div> {{ !!data.rate ? $filters.formatCurrency(data.rate, $userInfo.locale) : '-' }} </div> -->
                      <div class="is-flex is-justify-content-center">
                        <span v-tippy="{ theme: 'secondary', enabled: true }"
                          content="Report"
                          v-if="item.reportOnly"
                          class="tag is-danger p-1 px-2 is-dark">R
                        </span>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <section class="modal-card-body">

            <div v-if="finishFetchingTemplates && !isTemplateListNonEmpty"
            class="field">
            <span class="has-text-danger is-italic">
              <i class="mdi mdi-alert-outline" />
              No templates available. Please contact your admin to create a new template under
              <span class="has-text-weight-bold">Quote > Quote Template.</span>
            </span>
          </div>
          <div class="field">
            <label class="label">{{ label }}</label>
            <div class="select is-fullwidth">
              <select v-model="selectedTemplate"
              :disabled="finishFetchingTemplates && !isTemplateListNonEmpty">
              <option value="null"
              disabled>Select</option>
              <option v-for="(template, index) in templates"
              :key="index"
              :value="template">{{ template.name }}</option>
            </select>
          </div>
        </div>
      </section> -->
          </section>
          <footer class="modal-card-foot"
            :style="`justify-content: flex-end`">
            <button class="button"
              @click="close">
              <span class="material-symbols-outlined mr-1">close</span>
              <span>Close</span>
            </button>
            <button class="button is-primary"
              @click="handleAddTemplateItems"
              :disabled="!isTemplateSelected">Add to Quote</button>
          </footer>
        </div>
      </div>
    </base-modal-ex>
  </div>
</template>

<script>
import BaseModalEx from '@/components/BulmaModal/BaseModalEx'
import QuoteTemplateService from '@/services/QuoteTemplateService'
import Spinner from '../../../../components/Spinners/Spinner.vue'
import { getTextColor } from '../../../../utils/ColorFunctions'
import { EventHubTypes } from '../../../../enums'
import TagsDropdownMenu from '../../../manageTag/TagsDropdownMenu.vue'
import TagsService from '../../../manageTag/TagsService'

export default {
  name: 'TemplateItemsModal',
  components: {
    BaseModalEx,
    Spinner,
    TagsDropdownMenu
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    selectedTemplate: {
      type: Object,
      default: null
    },
    tags: {
      // <-- Pass tags as a prop!
      type: Array,
      default: () => []
    },
    rates: {
      type: Array,
      required: true
    },
    animationIn: {
      type: String,
      default: 'fadeIn'
    },
    animationOut: {
      type: String,
      default: 'fadeOut'
    },
    animationDuration: {
      type: Number,
      default: 0.3
    },
    label: {
      type: String,
      default: 'Select Template'
    },
    vehcile: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isLoading: false,
      templateItems: [],
      isActive: this.active || false,
      sortOrder: [
        { name: 'Remove & Refit', key: 'RR' },
        { name: 'Repair', key: 'REP' },
        { name: 'Paint', key: 'PAINT' },
        { name: 'Mechanical', key: 'MECH' },
        { name: 'Parts', key: 'PART' },
        { name: 'Sublet', key: 'SUBL' },
        { name: 'MISC', key: 'MISC' }
      ],
      sortedData: [],
      selectedItems: [],
      tagDropdownActive: false,
      selectedTagIDs: [],
      tagUpdateMessage: '',
      tagUpdateSuccess: null,
      originalTagIDs: []
    }
  },
  computed: {
    isTemplateSelected() {
      return this.selectedTemplate !== null
    },
    areAllSelected() {
      return this.templateItems.length === this.selectedItems.length
    }
  },
  watch: {
    selectedTemplate: {
      immediate: true,
      handler(newVal) {
        if (newVal && Array.isArray(newVal.tags)) {
          this.selectedTagIDs = newVal.tags.map((tag) => tag.tagID)
        } else {
          this.selectedTagIDs = []
        }
      }
    },
    tagDropdownActive(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.updateTemplateTags()
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutsideTagDropdown)
    this.getTemplateItems()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutsideTagDropdown)
  },
  methods: {
    getSortedData() {
      this.sortedData = this.sortOrder.map((order) => {
        const items = this.templateItems.filter((item) => item.itemType === order.key)
        return {
          key: order.key,
          name: order.name,
          items,
          length: items.length,
          rate: this.rates.find((rate) => rate.labourCodeId === order.key)?.rate
        }
      })
    },

    getRate(key) {
      return this.rates.find((rate) => rate.labourCodeId === order.key)?.rate
    },

    handleSelectAll() {
      if (this.areAllSelected) {
        this.selectedItems = []
      } else {
        this.selectedItems = this.templateItems.map((item) => item.itemId)
      }
    },
    handleItemClick(item) {
      // if item is not in selectedItems, add it
      if (!this.selectedItems.includes(item.itemId)) {
        this.selectedItems.push(item.itemId)
      } else {
        // if item is in selectedItems, remove it
        const index = this.selectedItems.indexOf(item.itemId)
        this.selectedItems.splice(index, 1)
      }
    },
    isItemSelected(item) {
      return this.selectedItems.includes(item.itemId)
    },
    areAllItemsSelected(items) {
      return items.length === items.filter((item) => this.selectedItems.includes(item.itemId)).length && items.length > 0
    },
    handleSelectAllItems(items) {
      if (this.areAllItemsSelected(items)) {
        this.selectedItems = this.selectedItems.filter((itemId) => !items.map((item) => item.itemId).includes(itemId))
      } else {
        this.selectedItems = [...new Set([...this.selectedItems, ...items.map((item) => item.itemId)])]
      }
    },

    async getTemplateItems() {
      this.isLoading = true
      const id = this.selectedTemplate.templateId
      if (!id) return
      const templateItems = await QuoteTemplateService.getSortedQuoteTemplateItems(id)
      this.templateItems = templateItems
      this.isLoading = false

      this.getSortedData()

      this.selectedItems = templateItems.map((item) => item.itemId)
    },
    close() {
      this.isActive = false
      this.updateTemplateTags()
      this.$emit('update:active', false)
      this.$emit('close')
      this.$eventHub.$emit(EventHubTypes.ReloadQuoteTemplate)
    },
    handleAddTemplateItems() {
      let labourItems = []
      let miscItems = []
      let otherItems = []
      let subletItems = []
      let partItems = []

      this.selectedItems.forEach((itemId) => {
        const item = this.templateItems.find((item) => item.itemId === itemId)
        if (item.itemType === 'RR' || item.itemType === 'REP' || item.itemType === 'PAINT') {
          labourItems.push(item)
        } else if (item.itemType === 'MISC') {
          miscItems.push(item)
        } else if (item.itemType === 'SUBL') {
          subletItems.push(item)
        } else if (item.itemType === 'PART') {
          partItems.push(item)
        } else {
          otherItems.push(item)
        }
      })
      const obj = {
        labourItems,
        miscItems,
        otherItems,
        subletItems,
        partItems
      }
      this.$emit('addTemplateItemsCustom', obj)
      this.close()
    },
    toggleTagDropdown() {
      this.tagDropdownActive = !this.tagDropdownActive
      if (this.tagDropdownActive) {
        this.tagUpdateMessage = ''
        this.tagUpdateSuccess = null
        // Store a copy of the current tag IDs
        this.originalTagIDs = [...this.selectedTagIDs]
      }
    },
    handleClickOutsideTagDropdown(event) {
      const dropdown = this.$refs.tagDropdown
      if (dropdown && !dropdown.contains(event.target)) {
        this.tagDropdownActive = false
      }
    },
    toggleTag(tag) {
      const idx = this.selectedTagIDs.indexOf(tag.tagID)
      if (idx === -1) {
        this.selectedTagIDs.push(tag.tagID)
      } else {
        this.selectedTagIDs.splice(idx, 1)
      }
    },
    getTextColor,
    async getNtarTimesForLabourItems(labourItems) {
      return []
    },
    async updateTemplateTags() {
      if (!this.selectedTemplate) return
      const a = [...this.originalTagIDs].sort().join(',')
      const b = [...this.selectedTagIDs].sort().join(',')
      if (a !== b) {
        try {
          // const result = await QuoteTemplateService.addQuoteTemplateTag(this.selectedTemplate.templateId, this.selectedTagIDs)
          const result = await TagsService.updateAssetTags(this.selectedTemplate.templateId, this.selectedTagIDs)
          if (result === true) {
            this.tagUpdateMessage = 'Tags updated successfully.'
            this.tagUpdateSuccess = true
          } else {
            this.tagUpdateMessage = 'Failed to update tags.'
            this.tagUpdateSuccess = false
          }
        } catch (e) {
          this.tagUpdateMessage = 'Failed to update tags.'
          this.tagUpdateSuccess = false
        }
      }
    },
    clearAllTags() {
      this.selectedTagIDs = []
    }
  }
}
</script>

<style scoped>
.template-item-grid {
  display: grid;
  grid-template-columns: 3% 84% 13%;
}
</style>

<style lang="scss">
@use '@/assets/style/override-colours' as oc;

.border-bottom-primary {
  border-bottom: 1px solid oc.$primary;
}

.template-items-modal,
.modal-card {
  min-width: 800px;
  width: 60vw;
}

.template-items-container {
  overflow-y: auto;
  max-height: 50vh;
}

.template-item-grid {
  // grid-gap: 1rem;

  &.is-title {
    position: sticky;
    top: -1px;
    border-bottom: 1px;
    z-index: 3;
    border-top: 1px solid rgba(oc.$grey, 0.3);
    border-bottom: 1px solid rgba(oc.$grey, 0.3);
  }
}
</style>